<template>
  <div v-show = "!isHidePhoneOption">
    <m-loader :show="!demoInit" size="smBox"/>
    <b-form-radio-group v-model="selectedPhoneOption"
                        stacked
                        :disabled="disabled"
                        v-show="demoInit"
                        >
      <b-form-radio v-for="(item,index) in phoneOptions"
                    :key = "item.value"
                    :value = "item.value"
                    :data-test = "`demo-phoneOption-${index}`"
      >
        {{item.desc}}
        <span v-show="(item.value === '2' || item.value === '3') && !isBusiness">*</span>
        <!--<div v-show="selectedPhoneOption==2 && item.value==2">-->
          <!--<b-form-checkbox  class="iclude-dnc-list">-->
            <!--Include Phones on DNC list-->
          <!--</b-form-checkbox>-->
        <!--</div>-->
        <div v-show="selectedPhoneOption==2 && item.value==2">
          <span class="phone-span" style="font-size: 10px; color:#e04557;">* Please note New York and Louisiana prohibit telemarketing during declared states of emergency.</span>
        </div>
        <div v-show="selectedPhoneOption==3 && item.value==3">
          <span class="phone-span" style="font-size: 10px; color:#e04557;">* Please note New York and Louisiana prohibit telemarketing during declared states of emergency.</span>
        </div>
      </b-form-radio>
      <span class="phone-span" v-show="Object.keys(phoneOptions).length > 1 & !isBusiness" style="font-size: 10px">&nbsp;&nbsp;&nbsp;&nbsp;* Phone numbers have been pre-scrubbed against the Do Not Call list.</span>
      <p v-show ="noPhoneOption">No Phone Option</p>
    </b-form-radio-group>
  </div>
</template>

<script>
  export default {
    props: {
      disabled: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      isBusiness () {
        return this.$store.getters['demo/isBusiness']
      },
      selectedPhoneOption: {
        get () {
          return this.$store.state.order.PhoneOption
        },
        set (val) {
          this.$store.commit('order/savePhoneOption', val)
        }
      },
      demoInit () {
        return this.$store.state.demo.isInit
      },
      phoneOptions () {
        return this.$store.getters['demo/phoneOptions']
      },
      noPhoneOption () {
        return this.$store.getters['demo/noPhoneOption']
      },
      isHidePhoneOption () {
        return this.$store.getters['demo/isHidePhoneOption']
      }
    }
  }
</script>

<style scoped lang="scss">
  .phone-span {
    font-style: italic;
  }
</style>



// WEBPACK FOOTER //
// src/components/demo/MPhoneOption.vue